import React, { useState, useEffect } from 'react';
import { deleteMetaAd, getTrialAdFormJunctionList, getUnassignedMetaAdForm, linkMetaAdFormTrial } from '../../js/api/fb-integration';
import MultiSelectMetaAds from './multiselect-meta-ads';
import { BackButton } from '../common/back-button/back-button';
import AdsCard from './ads-card';
import SecondaryButton from '../common/buttons/SecondaryButton';
import { DelinkModalIcon } from '../../assets/icons/delink-modal-svg-icon';
import useMediaQuery from '../common/custom-hooks/use-media-query';
import { useLocation } from 'react-router';

const MetaAdsIntegration = ({ id, addToast }) => {
  const [apiLoader, setApiLoader] = useState(false)
  const [unassignedForms, setUnassignedForms] = useState([]);
  const [selectedUnassignedForms, setSelectedUnassignedForms] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [linkedForms, setLinkedForms] = useState([])
  const [isDelink, setIsDelink] = useState(null)
  const isBigDesktop = useMediaQuery("(min-width: 1440px)");
  const location = useLocation()

  function refreshData() {
    getUnassignedMetaAdForm(setUnassignedForms)
      .then(data => {
        setUnassignedForms(data); // Ensure it's an array
        getTrialAdFormJunctionList(id).then((res) => {
          res && res.data && res.data.trialAdFormJuncForms && res.data.trialAdFormJuncForms.length ? setLinkedForms(res.data.trialAdFormJuncForms) : setLinkedForms([])
        })
      })
      .catch(err => console.error(err));
  }

  useEffect(() => {
    refreshData();
  }, []);

  useEffect(() => {
    refreshData();
  }, [location.pathname]);

 

  
  const handleAdsChange = (ids) => {
    const allIDS = ids.adFormID
    const allNames = ids.adFormName
  };

  const link = () => {
    setApiLoader(true)
    const selectedMetaAdFormIDs = selectedOptions.map((item) => item.metaAdFormID)
    const payload = {
      "trialID": id,
      "metaAdFormIDs": selectedMetaAdFormIDs
    };

    linkMetaAdFormTrial(payload).then(response => {
      refreshData()
      setApiLoader(false)
      setSelectedOptions([])
      if (payload.metaAdFormIDs.length > 1) {
        addToast("All selected ads have been successfully connected.", "success")
      } else {
        addToast(`${selectedOptions[0].adFormName} has been successfully connected.`, "success")
      }

    }).catch((error) => {
      if (payload.metaAdFormIDs.length > 1) {
        addToast("Failed to connect all selected ads.", "success")
      } else {
        addToast(`Failed to connect ${selectedOptions[0].adFormName}.`, "success")
      }
    });
  }

  return (
    <>
      <div className='h-[calc(100vh-244px)] overflow-y-auto p-5 pt-0'>
        <MultiSelectMetaAds options={unassignedForms} onChange={handleAdsChange} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} />
        {linkedForms && linkedForms.length ? <div className={linkedForms.length > 5 ? `mt-9 ${isBigDesktop ? 'min-h-[73vh]' : "min-h-[70vh]"} mb-[100px] ` : 'mt-9'}>{linkedForms.map((item, idx) =>
          <AdsCard className={'mb-6'} data={item} key={idx} onClick={() => { setIsDelink(item) }} />
        )}</div> : ''}
      </div>
      {selectedOptions && selectedOptions.length ? <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-4 bottom-0 w-full bg-white pl-8 flex gap-5">
        <button type="submit" className="px-5 py-1 text-base rounded-md border primary_btn transition-all duration-500 min-w-[94px]" disabled={apiLoader} onClick={link} >{apiLoader ? <div className="flex justify-center"><div className="mini-spinner "></div></div> : "Save"}</button>
        <BackButton editTrial={true} />
      </div> : ''}
      {isDelink ?
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm z-50">
          <div className="bg-white w-[525px] md:w-[525px] rounded-lg shadow-lg p-[30px]">

            <div className="pt-0"><div className=" mb-[30px]">
              {/* <img src={imageSrc} className={`w-12 h-12 mr-4`} /> */}
              <div className='flex'>
                <div><DelinkModalIcon className={'mr-5'} /></div><h3 className="font-mont text-[16px] font-medium text-[#1B2A3D]"><span>Are you sure you want to disconnect</span>&nbsp;<span className="font-mont font-semibold text-[#1B2A3D]">{isDelink.adFormName}</span> ?</h3>
              </div>
            </div>
              <div className="flex justify-end">
                <button className="px-5 py-1 rounded-md border primary_btn transition-all duration-500 red_btn h-[42px] text-[14px] font-mont font-[500] mr-[20px]" onClick={() => {
                  deleteMetaAd(isDelink.metaAdFormTrialJuncID).then(() => {
                    getTrialAdFormJunctionList(id).then((res) => {
                      res && res.data && res.data.trialAdFormJuncForms && res.data.trialAdFormJuncForms.length ? setLinkedForms(res.data.trialAdFormJuncForms) : setLinkedForms([]);
                      addToast(`${isDelink.adFormName} has been successfully disconnected.`, "success");
                      setIsDelink(false);
                    }).catch(() => {
                      addToast(`Failed to disconnect ${isDelink.adFormName}`, "error");
                    })

                  })
                }}>Disconnect</button>
                <SecondaryButton label="Cancel" onClick={() => setIsDelink(false)} />
              </div>
            </div>
          </div>
        </div> : ''
      }
    </>
  );
};

export default MetaAdsIntegration;
